import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import auth from 'auth'

export const requireLogin = (Component) => {
  const Enhanced = (props) => {
    if (!auth.isLoggedIn()) {
      return (
        <Redirect
          to={{
            pathname: '/login/',
            search: props.location.search,
            state: { prev: props.location },
          }}
        />
      )
    }
    return <Component {...props} />
  }

  Enhanced.propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
  }

  return Enhanced
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hoc/RequireLogin/index.js